export default {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1299,
  },
  modalContainer: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1300,
    width: 800,
    height: 600,
  },
  card: {
    height: '100%',
  },
  headerContainer: {
    float: 'right',
    cursor: 'pointer',
    background: 'darkgray',
    borderRadius: 50,
    boxShadow: '10px 10px 50px gray',
  },
  headerIcon: {
    marginRight: 8,
  },
  headerTitle: {
    flexGrow: 1,
  },
  closeButton: {
    float: 'right',
    cursor: 'pointer',
    background: 'darkgray',
    borderRadius: 50,
    boxShadow: '10px 10px 50px gray',
  },
  closeIcon: {
    fontSize: 16,
  },
  cardBody: {
    padding: 16,
    paddingBottom: 0,
  },
  contentContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 32,
  },
  title: {
    textAlign: 'center',
  },
  avatar: {
    borderRadius: '50%',
    overflow: 'hidden',
    padding: 4,
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'relative',
  },
  inlineContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
  },
  inlineText: {
    minWidth: 140,
    textAlign: 'right',
    textTransform: 'uppercase',
    color: '#3D5465',
  },
  iconContainer: {
    maxHeight: 250,
    overflowY: 'auto',
    border: '1px solid #ccc',
    borderRadius: 8,
    padding: 16,
  },
  footer: {
    padding: 16,
    paddingTop: 0,
    textAlign: 'right',
  },
  currentIconWrapper: {
    position: 'relative',
    width: 100,
    height: 100,
    marginLeft: 16,
    '&:hover $iconOverlay': {
      opacity: 1,
    },
  },
  iconOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    zIndex: 2,
  },
  iconDeleteBtn: {
    background: 'white',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    zIndex: 3,
  },

};
